import React, { useState } from 'react';
import { Container, Typography } from '@mui/material';
import ImageUploader from './components/ImageUploader';
import IconGenerator from './components/IconGenerator';
import ManifestGenerator from './components/ManifestGenerator';
import DownloadButton from './components/DownloadButton';

const App = () => {
    const [image, setImage] = useState(null);

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                PWA Icon Generator
            </Typography>
            <ImageUploader onUpload={setImage} />
            {image && (
                <>
                    <IconGenerator image={image} />
                    <ManifestGenerator />
                    <DownloadButton image={image} />
                </>
            )}
        </Container>
    );
};

export default App;
